import '../text';
import { defineCustomElement, NectaryElement, setClass, getAttribute, updateAttribute } from '../utils';
const templateHTML = '<style>:host{display:inline-block;vertical-align:middle}#wrapper{width:var(--sinch-global-size-icon,32px);height:var(--sinch-global-size-icon,32px);border-radius:50%}#wrapper.no-color{background:linear-gradient(45deg,var(--sinch-ref-color-complementary-orange-200),var(--sinch-ref-color-complementary-bolt-200),var(--sinch-ref-color-complementary-grass-200),var(--sinch-ref-color-complementary-night-200),var(--sinch-ref-color-complementary-violet-200))}</style><div id="wrapper"></div>';
import { getSwatchColorBg } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-color-swatch', class extends NectaryElement {
  #$wrapper;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$wrapper = shadowRoot.querySelector('#wrapper');
  }
  connectedCallback() {
    super.connectedCallback();
    this.#updateColor();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  static get observedAttributes() {
    return ['name'];
  }
  attributeChangedCallback(name) {
    switch (name) {
      case 'name':
        {
          this.#updateColor();
          break;
        }
    }
  }
  get name() {
    return getAttribute(this, 'name');
  }
  set name(value) {
    updateAttribute(this, 'name', value);
  }
  #updateColor() {
    if (!this.isDomConnected) {
      return;
    }
    const colorName = this.name;
    if (colorName !== null && colorName.length > 0) {
      const bg = getSwatchColorBg(colorName);
      this.#$wrapper.style.setProperty('background-color', bg);
      setClass(this.#$wrapper, 'no-color', false);
    } else {
      this.#$wrapper.style.removeProperty('background-color');
      setClass(this.#$wrapper, 'no-color', true);
    }
  }
});